import { render, staticRenderFns } from "./IsFieldRequired.vue?vue&type=template&id=2b46bfb8"
import script from "./IsFieldRequired.vue?vue&type=script&lang=js"
export * from "./IsFieldRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports